import { useEffect } from 'react';

function PageTitle(title) {
    useEffect(() => {
        if (title?.trim() === 'undefined' || title?.trim() === 'null' || title?.trim() === '') {
            document.title = 'Instaportal';
        } else {
            document.title = ` ${title} || Instaportal`;
        }
    }, [title]);
}

export default PageTitle;
